<template>
    <b-form-group v-if="hasFormGroup"
                  :label="computedLabel"
                  label-for="remaining-closures-select"
                  :label-cols-sm="labelColsSm"
                  :label-cols-md="labelColsMd"
                  :label-cols-lg="labelColsLg"
                  :label-cols-xl="labelColsXl"
                  :content-cols-="contentColsSm"
                  :content-cols-md="contentColsMd"
                  :content-cols-lg="contentColsLg"
                  :content-cols-xl="contentColsXl">

        <template #label>
            {{ computedLabel }}
            <i
                v-if="computedTooltip" class="fas fa-info-circle text-muted cursor-help ml-1"
                v-b-tooltip.hover
                :title="computedTooltip"
            ></i>
        </template>

        <multiselect
            id="remaining-closures-select"
            placeholder="-"
            :searchable="false"
            :show-no-results="true"
            :allowEmpty="allowEmpty"
            :disabled="disabled || loading"
            open-direction="bottom"
            :options="options"
            v-model="selectedOption"
            track-by="id"
            label="label"
        >
            <template v-if="showClearIcon" slot="clear">
                <div
                    class="multiselect__clear"
                    @mousedown.prevent.stop="clearValue"
                ></div>
            </template>

        </multiselect>
    </b-form-group>

    <multiselect
        v-else
        id="remaining-closures-select"
        placeholder="-"
        :searchable="false"
        :show-no-results="true"
        :allowEmpty="allowEmpty"
        :disabled="disabled || loading"
        open-direction="bottom"
        :options="options"
        v-model="selectedOption"
        track-by="id"
        label="label"
    >
        <template v-if="showClearIcon" slot="clear">
            <div
                class="multiselect__clear"
                @mousedown.prevent.stop="clearValue"
            ></div>
        </template>

    </multiselect>
</template>
<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import {sortBy} from "lodash";
import {CustomSelectMixin} from "../js/mixins";

export default {
    name: "RtCertificationExpirationSelect",
    mixins: [CustomSelectMixin],
    components: {
        Multiselect,
    },
    created() {
        this.options = [
            {
                id: 1,
                label: this.$tc("Within {count} month(s)", 1, {count: 1}),
                value: 1
            },
            {
                id: 2,
                label: this.$tc("Within {count} month(s)", 2, {count: 2}),
                value: 2,
            },
        ];

        this.loading = false;
    },
};
</script>
